import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import actions from 'redux/action'
import { selectPreference } from 'redux/selector/user'

type ValueOrFunc<T> = T | ((prev: T) => T)

export const usePreferenceItem = <T = any>(
  name: string,
  defaultValue?: T
): [T, (valueOrFunc: ValueOrFunc<T>) => void] => {
  const preference = useSelector((state: any) => selectPreference(state))
  const dispatch = useDispatch()
  const value: T = preference[name] ?? defaultValue ?? null
  const setValue = useCallback(
    (valueOrFunc: ValueOrFunc<T>) => {
      let nextValue: T
      if (typeof valueOrFunc === 'function') {
        nextValue = (valueOrFunc as (prev: T) => T)(value)
      } else {
        nextValue = valueOrFunc
      }

      const newPref = { ...preference, [name]: nextValue }
      if (nextValue == null) {
        delete newPref[name]
      }
      dispatch(actions.updatePreference(newPref))
    },
    [dispatch, name, preference, value]
  )

  const obj = useMemo(() => [value, setValue] as [T, (valueOrFunc: ValueOrFunc<T>) => void], [setValue, value])
  return obj
}
